import {Room} from "@/core/api/room.api";

export default {
  documentVisibilityState: (state, getters, rootState) => {
    return state.documentVisibilityState;
  },
  lowPowerMode: (state, getters, rootState) => {
    return state.lowPowerMode;
  },
  deviceSettings: (state, getters, rootState) => {
    let deviceSettings = state.deviceSettings;
    if(!deviceSettings || deviceSettings.init === false){
      deviceSettings = Room.Call.Stream.getLocalDeviceSetting();
      // state.deviceSettings = deviceSettings;
    }

    return deviceSettings;
  },
  devices: (state, getters, rootState) => {
    return state.devices;
  },
  roomDataInitComplete: (state, getters, rootState) => {
      return state.roomDataInitComplete;
  },

  connectionState: (state) => {
    return state.connectionState;
  },
  isLeaved: (state) => {
    return state.leaved;
  },

  room: (state, getters, rootState) => {
    if(Object.keys(state.room).length === 0) return {}

    return state.room;
  },

  roomUserCount: (state, getters, rootState) => {
    return state.room.currJoinCnt;
  },

  roomLms: (state, getters, rootState, rootGetters) => {
    return state.roomLms
  },
  
  roomScheduleList: (state, getters, rootState) => {
    return state.roomScheduleList
  },

  currentSchedule: (state, getters, rootState, rootGetters) => {
    return getters.roomScheduleList.find(rs => rs.scheduleState)
  },

  nextSchedule: (state, getters, rootState, rootGetters) => {
    return getters.roomScheduleList.find(v => getters.currentSchedule?.seq + 1 === v.seq)
  },

  roomGoalList: (state, getters, rootState) => {
    return state.roomGoalList
  },

  roomMode: (state, getters, rootState) => {
    return state.room.roomMode
  },

  prevRoomMode: (state, getters, rootState) => {
    return state.room.prevRoomMode
  },

  isRoomMode: (state, getters, rootState) => roomMode => {
    if (Array.isArray(roomMode)) {
      return roomMode.includes(getters.roomMode);
    }
    return getters.roomMode === roomMode;
  },

  isRoomType: (state, getters, rootState, rootGetters) => roomType => {
    return getters.room.roomType === roomType;
  },

  isEdu: (state, getters, rootState, rootGetters)  => {
    return getters.isRoomType('edu');
  },
  isConf: (state, getters, rootState, rootGetters)  => {
    return getters.isRoomType('conf');
  },
  isCamStudy: (state, getters, rootState, rootGetters)  => {
    return state.camStudyType.includes(state.room?.roomType)
  },

  isScreenShareMode: (state) => {
    let roomUser = state.roomUserList.find(roomUser => roomUser.screenStatus);
    return !!roomUser;
  },

  showParticipationRate: (state) => {
    return state.showParticipationRate
  },

  getRoomGroupName: (state) => (roomGroupId) => {
    let index = state.roomGroupList.findIndex(rg => rg.roomGroupId == roomGroupId)
    if(index < 0) return;
    return state.roomGroupList[index].roomGroupName
  },
  tabMode: (state) => {
    return state.tabMode;
  },
  isTabMode: (state, getters, rootState, rootGetters) => (tabMode) => {
    return getters.tabMode === tabMode;
  },
  oneLineMixerLayoutCount: (state, getters, rootState, rootGetters) => {
    return state.oneLineMixerLayoutCount;
  },
  testLayoutList: (state, getters, rootState, rootGetters) => {
    return state.testLayoutList;
  },
  normalLayoutList: (state, getters, rootState, rootGetters) => {
    return state.normalLayoutList;
  },
  presentationLayoutList: (state, getters, rootState, rootGetters) => {
    return state.presentationLayoutList;
  },
  isShowSideWrap: (state, getters, rootState, rootGetters) => {
    return state.isShowSideWrap;
  },
  readyToSchedule: (state, getters, rootState, rootGetters) => {
    return state.readyToSchedule;
  },
  readyToScheduleTime: (state, getters, rootState, rootGetters) => {
    return state.readyToScheduleTime;
  },

  // 화면공유 사용 여부
  useScreen: (state, getters, rootState, rootGetters) => {
    return getters.room.useScreen;
  },

  noiseCancelAvailable: function(state){
    return state.noiseCancelAvailable;
  },
  isModalDeviceSetting: function(state){
    return state.isModalDeviceSetting;
  },
  roomInfo: function(state)  {
    return state.roomInfo
  },
  roomInfoSetting: function(state, getters, rootState, rootGetters)  {
    return getters.roomInfo.setting
  },
  getRoomInfoModule: (state, getters) => (module) => {
    return getters.roomInfo[module]
  },
  isFullScreen: function(state)  {
    return state.isFullScreen
  },
  useDefinePasswd: function(state)  {
    return state.room.definePasswd;
  },
  participantListRoleId: function(state, getters, rootState, rootGetters)  {
    return getters.roomInfoSetting?.participantListRoleId || 'participant';
  },
  isPremiumRoom: function(state, getters, rootState, rootGetters) {
    return getters.room?.roomLevel === 'PREMIUM_PLUS';
  },
  isOpen: function(state)  {
    return state.room.open
  }
}
